import { MinimalSymbol } from 'features/processFlowDiagrams/data/MinimalSymbols'
import FeederRotaryTable from 'features/processFlowDiagrams/svg/feeders/feeder-rotary-table.svg?react'
import ProportionalFeeder from 'features/processFlowDiagrams/svg/feeders/proportional-feeder.svg?react'
import ProportionalFeederMetering from 'features/processFlowDiagrams/svg/feeders/proportional-feeder-metering.svg?react'
import ProportionalFeederRotaryValve from 'features/processFlowDiagrams/svg/feeders/proportional-feeder-rotary-valve.svg?react'
import SprayNozzle from 'features/processFlowDiagrams/svg/feeders/spray-nozzle.svg?react'
import React from 'react'

export const PID_FEEDERS_SYMBOLS: MinimalSymbol[] = [
  {
    id: 'feeder-rotary-table',
    name: 'Feeder (Rotary Table)',
    category: 'feeders',
    svgContent: <FeederRotaryTable />,
    viewBox: '0 0 104 100',
  },
  {
    id: 'proportional-feeder',
    name: 'Proportional Feeder',
    category: 'feeders',
    svgContent: <ProportionalFeeder />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'proportional-feeder-metering',
    name: 'Proportional Feeder (Metering)',
    category: 'feeders',
    svgContent: <ProportionalFeederMetering />,
    viewBox: '0 0 300 50',
  },
  {
    id: 'proportional-feeder-rotary-valve',
    name: 'Proportional Feeder (Rotary Valve)',
    category: 'feeders',
    svgContent: <ProportionalFeederRotaryValve />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'spray-nozzle',
    name: 'Spray Nozzle',
    category: 'feeders',
    svgContent: <SprayNozzle />,
    viewBox: '0 0 100 50',
  },
]
